import React, { useEffect, useState } from "react";
import axios from "axios";
import "./registration.css"; // Ensure the correct path

const Registration = () => {
  const [registrationFees, setRegistrationFees] = useState([]);
  const [registrationProcess, setRegistrationProcess] = useState([]); // State for registration process
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch registration fees
        const feesResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/registration-info`
        );
        setRegistrationFees(feesResponse.data);

        // Fetch registration process
        const processResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/registration-process`
        );
        setRegistrationProcess(processResponse.data);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Error fetching data");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  const highlightLinks = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #0d6efd;">${url}</a>`;
    });
  };
  

  return (
    <div className="registration-container">
      <div className="process-section">
        <div className="processTitle">
        <h1>Registration Process</h1>
        </div>
        <ul>
          {registrationProcess.length > 0 ? (
            registrationProcess.map((step, index) => (
              <li key={index}>
              <strong>Step {step.step_no}:</strong>{" "}
              <span
                dangerouslySetInnerHTML={{
                  __html: highlightLinks(step.process),
                }}
              />
            </li>
            ))
          ) : (
            <li>No registration process data available</li>
          )}
        </ul>
      </div>

      <div className="fees-section">
      <div className="processTitle">
      <h1>Registration Fees</h1>
        </div>
        <table>
          <thead>
            <tr>
              <th>Category</th>
              <th>JUST - Student</th>
              <th>JUST - Professional</th>
              <th>Others - Student</th>
              <th>Others - Professional</th>
            </tr>
          </thead>
          <tbody>
            {registrationFees.length > 0 ? (
              registrationFees.map((fee, index) => (
                <tr key={index}>
                  <td>{fee.category}</td>
                  <td>{fee.justStudent} BDT</td>
                  <td>{fee.justProfessional} BDT</td>
                  <td>{fee.othersStudent} BDT</td>
                  <td>{fee.othersProfessional} BDT</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No registration fees data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Registration;
